<template>
	<div class="fill-height pt-2">
        <v-card
            :width="$vuetify.breakpoint.width - 100"
            :style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null"
            class="rounded-lg fill-height py-0"
        >	
            <v-card-text :height="$vuetify.breakpoint.height - 200" class="pt-0 px-0">
                <v-tabs
                    v-model="tab" 
                    show-arrows 
                    height="35" 
                    :active-class="!$vuetify.theme.dark ? 'secondary-bg' : 'white'"
                >
                    <v-tab 
                        class="text-none text-capitalize rounded-tl"
                        :to="{ 
                            name: 'projects',
                        }"
                    >
                        Projects 
                    </v-tab>

                    <v-tab 
                        class="text-none text-capitalize"
                        :to="{ 
                            name: 'roles-at-project',
                        }"
                    >
                        Roles 
                    </v-tab>

                    <v-tab 
                        class="text-none text-capitalize"
                        :to="{ 
                            name: 'categories',
                        }"
                    >
                        Categories 
                    </v-tab>
                </v-tabs>
                <v-divider v-if="!$route.query.preview" class="mb-1"/>

                <!-- child page -->
                <router-view class="px-4" />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
	data () {
		return {
			tab: null
		}
	}
}
</script>

<style scoped>
.w-100 {
	width: 100%;
}
.secondary-bg {
	background-color: #FBF4DA
}
</style>
<style>
label.v-label.theme--light {
	color: black !important
}
</style>
